import { object, string } from "yup";

export const acquirerFeeSchema = object({
    pixFeePercentage: string().nullable().optional(),
    cardFeePercentage: string().nullable().optional(),
    pixFixedFee: string().nullable().optional(),
    cardFixedFee: string().nullable().optional(),
}).test("at-least-one-filled", "Preencha pelo menos uma taxa", (values) => {
    if (!values) return false;

    return Object.values(values).some((value) => {
        if (typeof value === "string") {
            return value.trim() !== "";
        }
        return value !== null && value !== undefined;
    });
});
